import React from "react";
import { TeamLogo } from "../shared/TeamLogo";

const PlayerName = ({ player_id, player_name, className }) =>
  player_id ? (
    <a href={`/player/${player_id}`} target="_blank" rel="noreferrer" className={`${className} hover:text-blue-600 hover:underline`}>
      {player_name || "Unknown"}
    </a>
  ) : (
    <span className={className}>{player_name || "Unknown"}</span>
  );

const pos = (position) => {
  if (!position) return "";
  return String(position).split("/")[0].split(",")[0].trim().toUpperCase();
};

export const PitchingLineup = ({ lineup, teamName, teamId }) => {
  if (!lineup || lineup.length === 0) {
    return <div className="text-sm text-gray-400 italic">No pitching data available</div>;
  }

  const sorted = [...lineup].sort((a, b) => (a.pitch_order || 999) - (b.pitch_order || 999));

  return (
    <div>
      <div className="flex items-center gap-2 pb-2 mb-2 border-b border-gray-200">
        <TeamLogo teamId={teamId} teamName={teamName} size="w-6 h-6" />
        <h3 className="text-sm font-semibold text-gray-800">{teamName} Pitchers</h3>
      </div>
      <div>
        {sorted.map((player, idx) => (
          <div key={idx} className="flex items-center gap-3 py-1.5 px-1 border-b border-gray-100 last:border-0">
            <span className="w-5 text-right text-xs text-gray-400 shrink-0">{player.pitch_order || idx + 1}</span>
            <PlayerName player_id={player.player_id} player_name={player.player_name} className="text-sm text-gray-800 flex-1 min-w-0 truncate" />
            <span className="text-xs font-medium text-gray-400 shrink-0">{pos(player.position)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
